import { useState } from "react";
import { Tab, ContainerTable } from "./components";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import useDrag from "./hooks/useDrag";

import "react-horizontal-scrolling-menu/dist/styles.css";


export const Schedule = ({ type }) => {
  const [btnActive, setBtnActive] = useState("1");
  const [currentDataTable, setCurrentDataTable] = useState(scheduleTabs.default);

  const [currentColumnsData, setCurrentColumnsData] = useState();

  const { dragStart, dragStop, dragMove } = useDrag();

  const handleDrag =
    ({ scrollContainer }) =>
    (ev) =>
      dragMove(ev, (posDiff) => {
        if (scrollContainer.current) {
          scrollContainer.current.scrollLeft += posDiff;
        }
      });

  const onWheel = (apiObj, ev) => {
    const isThouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;

    if (isThouchpad) {
      ev.stopPropagation();
      return;
    }

    if (ev.deltaY < 0) {
      apiObj.scrollNext();
    } else if (ev.deltaY > 0) {
      apiObj.scrollPrev();
    }
  };

  return (
    <>
      <ScrollMenu
        onWheel={onWheel}
        onMouseDown={() => dragStart}
        onMouseUp={() => dragStop}
        onMouseMove={handleDrag}
      >
        {scheduleTabs.data.map((tab) => (
            <Tab
              key={tab.id}
              btnActive={btnActive}
              setBtnActive={setBtnActive}
              from={tab.from}
              to={tab.to}
              id={tab.id}
              oneWayTrip={tab.oneWayTrip}
              returnTrip={tab.returnTrip}
              setCurrentDataTable={setCurrentDataTable}
              setCurrentColumnsData={setCurrentColumnsData}
            />
          ))}
      </ScrollMenu>

      {currentColumnsData && (
        <ContainerTable data={currentDataTable} columns={currentColumnsData} />
      )}
    </>
  );
};
